import { useAuth } from '@/lib/auth-context';
import {
  appName,
  appSurface,
  hasOtherSurfaceProducts,
  otherSurface,
  SURFACE_NAMES,
  SURFACE_URLS,
} from '@/lib/app-surface';

/** Shown when a signed-in user's organization doesn't have this app (Data Collection or Orca). */
export function NoAppAccess() {
  const { user, logout } = useAuth();
  const other = otherSurface(appSurface);
  const canSwitch = other !== null && hasOtherSurfaceProducts(user?.allProducts, appSurface);
  const roleBlocked = user?.surfaceAccess === 'role_blocked';

  return (
    <div className="grid min-h-full place-items-center bg-atlas-canvas p-6">
      <div className="atlas-panel max-w-lg p-8 text-center" role="alert">
        <div className="atlas-kicker">{appName}</div>
        <h1 className="atlas-heading mt-2">
          {roleBlocked ? `Your account doesn't use ${appName}` : `Your organization doesn't have access to ${appName}`}
        </h1>
        <p className="mt-3 text-xs leading-5 text-atlas-muted">
          {roleBlocked
            ? `Your role works in ${other ? SURFACE_NAMES[other] : 'another app'}. Ask your admin if you need ${appName}.`
            : `Ask your admin to enable ${appName} for ${user?.tenantName || 'your organization'}.`}
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          {canSwitch && other && (
            <a href={SURFACE_URLS[other]} className="atlas-button-primary">
              Go to {SURFACE_NAMES[other]}
            </a>
          )}
          <button type="button" className="atlas-button-secondary" onClick={() => void logout()}>
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
